import { CommonNS } from "../../../../Common/CommonNS.js";
import { VONS } from "../../VO/VONS.js";
export class Point {
  constructor(init_point) {
    this._point_observer_set = new Set();
    this._is_show_observer_set = new Set();
    this._is_selected_observer_set = new Set();
    this._x = init_point?.x ?? 0;
    this._y = init_point?.y ?? 0;
    this._is_show = init_point?.is_show ?? false;
    this._is_selected = init_point?.is_selected ?? false;
  }
  subscribePoint(observer) {
    if (this._point_observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer({
      x: this._x,
      y: this._y,
    });
    this._point_observer_set.add(observer);
    return () => {
      this._point_observer_set.delete(observer);
    };
  }
  subscribeIsShow(observer) {
    if (this._is_show_observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._is_show);
    this._is_show_observer_set.add(observer);
    return () => {
      this._is_show_observer_set.delete(observer);
    };
  }
  subscribeIsSelected(observer) {
    if (this._is_selected_observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._is_selected);
    this._is_selected_observer_set.add(observer);
    return () => {
      this._is_selected_observer_set.delete(observer);
    };
  }
  setPoint({ x, y }) {
    this._x = x;
    this._y = y;
    this._notifyPoint({
      x: this._x,
      y: this._y,
    });
  }
  show() {
    this._is_show = true;
    this._notifyIsShow(this._is_show);
  }
  hide() {
    this._is_show = false;
    this._notifyIsShow(this._is_show);
  }
  select() {
    this._is_selected = true;
    this._notifyIsSelected(this._is_selected);
  }
  unselect() {
    this._is_selected = false;
    this._notifyIsSelected(this._is_selected);
  }
  _notifyPoint(point_vo) {
    for (const observer of this._point_observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(point_vo));
    }
  }
  _notifyIsShow(is_show) {
    for (const observer of this._is_show_observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(is_show));
    }
  }
  _notifyIsSelected(is_selected) {
    for (const observer of this._is_selected_observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(is_selected));
    }
  }
}
